import $ from 'jquery';
import { spin } from './_site';
import { createAlert } from './window';
import { formatValue } from './field';
import { getData, validatefields } from './form';
import { markPreRemove, cancelPreRemove, hasPreRemove } from './pre-remover';
import { refresh as refreshProductSliders } from './products-slider';
import Mustache from '../../../_lib/plugins/mustache/mustache';

export const toggleLoading = (flag) => {
    var $cartModal = $('#cart-modal'),
        $modal = $('.modal.in');

    if (flag) {
        $modal.modal('hide');
        $cartModal.addClass('cart-modal--loading');
    } else {
        $cartModal.removeClass('cart-modal--loading');
    }
};
export const isCartLoading = () => {
    var $cartModal = $('#cart-modal');

    // prevent multiple clicks
    if ($cartModal.hasClass('cart-modal--loading')) {
        return true;
    }

    return false;
};
export const renderCartItems = (response) => {
    const { itemTemplate, items } = response;
    let $cartEmpty = $('#cart-empty'),
        $cartList = $('.cart-list'),
        cartListOutput = '';

    if (!itemTemplate) {
        console.error('Invalid cart item template');
    }

    // Populate items
    if (items.length) {
        items.map((item) => {
            // Add soft remove attribute
            item.softRemove = hasPreRemove(generateSoftRemoveKey(item.id));

            cartListOutput += Mustache.render(itemTemplate, item);
        });
    }

    $cartList.html(cartListOutput);

    // Show / hide correct messages
    if ($cartList.children().length) {
        $cartEmpty.hide();
        $cartList.show();
    } else {
        $cartEmpty.show();
        $cartList.hide();
    }
};
export const generateSoftRemoveKey = (id) => {
    return 'cartItem:' + id;
};
export const undoRemove = ($el) => {
    let $form = $el.closest('.form'),
        id = $form.find('[name=id]').val(),
        key = generateSoftRemoveKey(id),
        $cartItem = $el.closest('.cart-list__item');

    $cartItem.removeClass('cart-list__item--removing');
    cancelPreRemove(key);
};
export const preRemove = ($el) => {
    let $form = $el.closest('.form'),
        id = $form.find('[name=id]').val(),
        key = generateSoftRemoveKey(id),
        $cartItem = $el.closest('.cart-list__item');

    $cartItem.addClass('cart-list__item--removing');

    // Set timeout
    markPreRemove(key);
};
export const removeById = (id) => {
    let $cartListItem = $('.cart-list [name=id][value=' + id + ']').closest(
        '.cart-list__item'
    );

    if ($cartListItem.length) {
        remove($cartListItem);
    }
};
export const remove = ($el) => {
    var $submit = $el,
        $form = $submit.closest('.form'),
        // $fields = $form.find('input, select, textarea'),
        $cartListItem = $el.closest('.cart-list__item'),
        url = $form
            .parent()
            .closest('.form')
            .data('remove-action'),
        data = getData($form);

    // prevent multiple clicks
    if (isCartLoading()) {
        return false;
    }

    console.log(data);

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoading(true);
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                // remove soft remove
                undoRemove($el);

                if ($cartListItem && $cartListItem.length) {
                    $cartListItem.slideUp(250, function() {
                        updateView(response);
                    });
                } else {
                    updateView(response);
                }
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoading(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoading(false);
            // remove soft remove
            // undoRemove($el);
        },
    });
};
export const add = ($el) => {
    var $submit = $el,
        $submitAux = $submit.children('span'),
        $form = $submit.closest('.form'),
        // $fields = $form.find('input, select, textarea'),
        url = $form.data('action'),
        data = getData($form),
        submitClass = 'form__submit',
        spinner = $.extend(true, {}, spin);

    function toggleLoader(flag) {
        if (flag) {
            // add loader
            $submit.addClass(submitClass + '--loading');
            $submitAux.spin(spinner);
        } else {
            // remove loader
            $submit.removeClass(submitClass + '--loading');
            $submitAux.spin(false);
        }
    }

    // validation errors
    if (!validatefields($form, true)) {
        return false;
    }

    console.log(data);

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoader(true);
            // toggleLoading(true);
            // toggle();
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                if (response.url) {
                    window.location.href = response.url;
                    return;
                }

                // create alert
                if (response.message) {
                    createAlert(response, 'success');
                }

                // displayRecommendedProducts();
                updateView(response);
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoader(false);
            toggleLoading(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoader(false);
            // toggleLoading(false);
        },
    });
};
export const update = ($el) => {
    var $submit = $el,
        $form = $submit.closest('.form'),
        // $fields = $form.find('input, select, textarea'),
        url = $form
            .parent()
            .closest('.form')
            .data('update-action'),
        data = getData($form);

    // prevent multiple clicks
    if (isCartLoading()) {
        return false;
    }

    console.log(data);

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoading(true);
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                updateView(response);
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoading(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoading(false);
        },
    });
};
export const triggerRequestCart = () => {
    let $cartList = $('.cart-list');
    if ($cartList.length) {
        $cartList.trigger('request.cart');
    }
};
export const request = ($el) => {
    var $form = $el,
        // $fields = $form.find('input, select, textarea'),
        url = $form.data('request-action'),
        data = getData($form);

    // prevent multiple clicks
    if (isCartLoading()) {
        return false;
    }

    console.log(data);

    // send data
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        cache: false,
        dataType: 'json',
        beforeSend: function() {
            // add loader
            toggleLoading(true);
        },
        success: function(response) {
            console.log(response);

            if (response.status) {
                updateView(response);
            } else {
                // create alert
                createAlert(response, 'error');
            }

            // remove loader
            toggleLoading(false);
        },
        error: function(response) {
            // create alert
            createAlert(response, 'error');
            // remove loader
            toggleLoading(false);
        },
    });
};
export const toggle = () => {
    $('body').removeClass('header-active menu-active');
    $('body').toggleClass('cart-active');
};
export const displayRecommendedProducts = () => {
    let $recommendedProducts = $('#added-to-cart-modal');

    if ($recommendedProducts.length && !$recommendedProducts.is(':visible')) {
        let $slider = $recommendedProducts.find('.products-slider');
        $recommendedProducts.modal('show');
        $slider.css('opacity', 0);

        setTimeout(function() {
            refreshProductSliders();
            $slider.animate(
                {
                    opacity: 1,
                },
                200
            );
        }, 1000);
    }
};
export const updateCartQuantity = (quantity) => {
    let $cartQty = $('.cart-total-items'),
        notificationClass = 'header-options__link--notification';

    if (typeof quantity != 'undefined') {
        if (quantity > 0) {
            $cartQty.addClass(notificationClass).attr('data-counter', quantity);
        } else {
            $cartQty.removeClass(notificationClass).attr('data-counter', 0);
        }
    }
};
export const updateView = (data) => {
    var $cartModal = $('#cart-modal'),
        $inputs;

    // cart items
    if (typeof data.items !== 'undefined' && data.items) {
        renderCartItems(data);
    }

    // cart qty
    if (typeof data.cartQty !== 'undefined') {
        updateCartQuantity(data.cartQty);
    }

    // trigger input values
    $inputs = $cartModal.find('input, select, textarea');
    formatValue($inputs);
};
// export const updateView = (data) => {
//     var $cartModal = $('#cart-modal'),
//         $cartQty = $('.cart-total-items'),
//         $inputs;
//
//     // cart
//     if (typeof(data.cartModal) !== 'undefined' && data.cartModal) {
//         $cartModal.replaceWith(data.cartModal);
//     }
//
//     // cart
//     if (typeof(data.cartQty) !== 'undefined') {
//         if (data.cartQty) {
//             $cartQty.show().attr('data-total-qty', data.cartQty);
//         }
//         else {
//             $cartQty.hide().attr('data-total-qty', 0);
//         }
//     }
//
//     // trigger input values
//     $inputs = $cartModal.find('input, select, textarea');
//     formatValue($inputs);
// };
export const binds = () => {
    // ---------------- cart list request
    $('.cart-list').on('request.cart', function(event) {
        request($(this));
    });

    triggerRequestCart();

    // ---------------- toggle loading
    $('#wrapper').on('loading', function(event, display) {
        toggleLoading(display);
    });

    // ---------------- toggle menu
    $('#wrapper').on('click.cart', '[data-toggle-cart]', function(event) {
        event.preventDefault();
        toggle();
    });

    // ---------------- preremove item from cart
    $('#wrapper').on('click.cart', '[data-preremove-cart]', function(event) {
        event.preventDefault();
        preRemove($(this));
    });

    // ---------------- remove item from cart
    $('#wrapper').on('click.cart', '[data-remove-cart]', function(event) {
        event.preventDefault();
        remove($(this));
    });

    // ---------------- undo remove item from cart
    $('#wrapper').on('click.cart', '[data-undo-remove-cart]', function(event) {
        event.preventDefault();
        undoRemove($(this));
    });

    // ---------------- add item to cart
    $('#wrapper').on('click.cart', '[data-add-cart]', function(event) {
        event.preventDefault();
        add($(this));
    });

    // ---------------- update qty
    $('#wrapper').on('change.cart', '#cart-modal .field--qty input', function(
        event
    ) {
        event.preventDefault();
        update($(this));
    });
};
